'use client'

import { QueryKey } from '@api'
import { useApi } from '@api/useApi.hook'
import type { ApiGETFn } from '@api/standaloneApi'
import { appConfig } from '@config'
import type { UserMeta } from '@domain/users'
import { useMutation, useQueryClient } from '@tanstack/react-query-v4'

type AcknowledgeTermsResponse = {
  meta: UserMeta
}

export const useAcknowledgeTermsUpdate = () => {
  const { post } = useApi()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (versionId: string) => {
      return (post as ApiGETFn)<AcknowledgeTermsResponse, { versionId: string }>(
        appConfig.endpoints.v1.me.termsAck,
      )({ versionId })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKey.Me] })
    },
  })
}
